import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles.css";

const Signup = () => {
  const { role = "student" } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    password: "",
    confirm: "",
  });

  const [toast, setToast] = useState({ message: "", show: false });

  const showToast = (message) => {
    setToast({ message, show: true });
    setTimeout(() => setToast({ message: "", show: false }), 3000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirm) {
      showToast("❌ Passwords do not match!");
      return;
    }

    if (formData.password.length < 8) {
      showToast("❌ Password must be at least 8 characters long.");
      return;
    }

    const signupData = {
      fullname: formData.fullname,
      email: formData.email,
      password: formData.password,
      role,
    };

    try {
      const response = await fetch("http://193.123.94.90/api/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signupData),
      });

      const data = await response.json();

      if (response.ok) {
        showToast(`✅ Signed up as ${role}. Logging in...`);

        const loginResponse = await fetch("http://193.123.94.90/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
          }),
        });

        const loginData = await loginResponse.json();

        if (loginResponse.ok) {
          localStorage.setItem("token", loginData.token);
          localStorage.setItem("role", loginData.role);

          if (loginData.user.role === "student") {
            navigate("/profile/student");
          } else if (loginData.user.role === "teacher") {
            navigate("/profile/teacher");
          } else {
            navigate("/dashboard");
          }
        } else {
          showToast("⚠️ Signup succeeded, but auto-login failed. Please login manually.");
          navigate("/login");
        }
      } else {
        showToast(`❌ Signup failed: ${data.message}`);
      }
    } catch (error) {
      console.error("Signup or login error:", error);
      showToast("🚫 Something went wrong. Please try again.");
    }
  };

  return (
    <div
      className="position-relative d-flex justify-content-center align-items-center min-vh-100"
      style={{ backgroundColor: "#ffeae9", overflow: "hidden" }}
    >
      <div
        style={{
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          opacity: 0.08,
          position: "absolute",
          inset: 0,
          zIndex: 0,
        }}
      ></div>

      {toast.show && (
        <div className="custom-toast position-absolute top-0 start-50 translate-middle-x mt-3">
          {toast.message}
        </div>
      )}

      {/* Signup Card */}
      <div
        className="bg-white rounded-4 shadow p-5 w-100 position-relative"
        style={{ maxWidth: "480px", zIndex: 1 }}
      >
        <h2 className="text-center mb-4">
          Sign up as {role.charAt(0).toUpperCase() + role.slice(1)}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="fullname" className="form-label">Full Name</label>
            <input
              type="text"
              id="fullname"
              className="form-control"
              value={formData.fullname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              id="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="confirm" className="form-label">Confirm Password</label>
            <input
              type="password"
              id="confirm"
              className="form-control"
              value={formData.confirm}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-peach w-100 mt-3">Sign Up</button>
        </form>

        <p className="text-center mt-3">
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
